import Vue from 'vue';

// Use only material stuff we use
import {
  MdButton, MdField, MdList, MdMenu, MdSnackbar, MdSteppers,
  MdProgress, MdCard, MdSwitch, MdDivider, MdSubheader,
  MdDialog, MdDialogAlert, MdDialogConfirm, MdDialogPrompt,
  MdTable, MdContent, MdRipple, MdDatepicker, MdTabs, MdBottomBar,
} from 'vue-material/dist/components';
import 'vue-material/dist/vue-material.min.css';
import 'vue-material/dist/theme/default.css';

import Axios from 'axios';
import router from './router';
import store from './store';
import App from './App.vue';

Vue.use(MdDialog);
Vue.use(MdDialogAlert);
Vue.use(MdDialogConfirm);
Vue.use(MdDialogPrompt);
Vue.use(MdButton);
Vue.use(MdField);
Vue.use(MdList);
Vue.use(MdDivider);
Vue.use(MdMenu);
Vue.use(MdProgress);
Vue.use(MdSubheader);
Vue.use(MdSnackbar);
Vue.use(MdSteppers);
Vue.use(MdTable);
Vue.use(MdCard);
Vue.use(MdSwitch);
Vue.use(MdContent);
Vue.use(MdRipple);
Vue.use(MdDatepicker);
Vue.use(MdTabs);
Vue.use(MdBottomBar);

Vue.prototype.$http = Axios;
const user = JSON.parse(localStorage.getItem('user'), null);
if (user) {
  Vue.prototype.$http.defaults.headers.common.Authorization = user.token;
}

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app');
